import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const usePulseOpportunities = function usePulseOpportunities() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.PulseOpportunities
        ],
        queryFn: ()=>api.pulse.getOpportunities(),
        refreshOnHookMount
    });
    return {
        feed: data,
        isLoading,
        error,
        refresh
    };
};
